export default class CiiCalculationResultData {
    constructor(cii, distance, averageLadenMeFoc, averageBallastMeFoc) {
        this.cii = cii;
        this.distance = distance;
        this.averageLadenMeFoc = averageLadenMeFoc;
        this.averageBallastMeFoc = averageBallastMeFoc;
    }
}
